var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var Integrations = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M19.875 12.375L14.4937 17.7562C14.2159 18.0352 13.8857 18.2565 13.5221 18.4075C13.1585 18.5585 12.7687 18.6362 12.375 18.6362C11.9813 18.6362 11.5915 18.5585 11.2279 18.4075C10.8643 18.2565 10.5341 18.0352 10.2562 17.7562L6.24375 13.7438C5.96483 13.4659 5.74351 13.1357 5.5925 12.7721C5.44149 12.4085 5.36375 12.0187 5.36375 11.625C5.36375 11.2313 5.44149 10.8415 5.5925 10.4779C5.74351 10.1143 5.96483 9.7841 6.24375 9.50625L11.625 4.125M8.25 15.75L3 21M13.5 6L17.25 2.25M21.75 6.75L18 10.5M21 13.5L10.5 3", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
